import React from "react";
import AadhaarInputForm from "./aadhaar";
import AadhaarOtpForm from "./otp";
import CustomerEkycBlank from "./blank";
import CustomerEkycMismatch from "./mismatch";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop, Box, Typography } from "@mui/material";
import { MESSAGE_SEND_AADHAAR_OTP, SLUG_OTP } from "../../../constants/index";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerEkycForm({
  classes: { main },
  backdrop,
  errorMessage,
  errors,
  form,
  handleBack,
  handleChange,
  handleOnClose,
  handleReinitiateJourney,
  handleResendOtp,
  handleRetryClick,
  handleClose,
  isFormSubmitted,
  modal,
  onfocusMobile,
  onSubmitGenerateOtp,
  onSubmitVerifyOtp,
  setFormState,
  toggleClass,
  validateInputLength,
}) {
  return (
    <Box className={main}>
      <Box mt={2}>
        <Box display="flex" justifyContent="center" m={2} mt={1}>
          <SectionTitle
            title={"KYC Verification"}
            onClickHandler={handleBack}
          />
        </Box>

        <AadhaarInputForm
          errors={errors}
          form={form}
          errorMessage={errorMessage}
          handleChange={handleChange}
          isFormSubmitted={isFormSubmitted}
          onfocusMobile={onfocusMobile}
          onSubmit={onSubmitGenerateOtp}
          toggleClass={toggleClass}
          validateInputLength={validateInputLength}
        />

        {form.step === SLUG_OTP && (
          <AadhaarOtpForm
            errors={errors}
            form={form}
            errorMessage={errorMessage}
            handleChange={handleChange}
            handleResendOtp={handleResendOtp}
            isFormSubmitted={isFormSubmitted}
            onSubmit={onSubmitVerifyOtp}
            setFormState={setFormState}
            validateInputLength={validateInputLength}
          />
        )}
        {form.isBlankEkycData && (
          <CustomerEkycBlank
            onClickHandler={handleRetryClick}
            onClose={handleOnClose}
            modal={modal}
          />
        )}

        {form.mismatch && (
          <CustomerEkycMismatch
            form={form}
            onClickHandler={handleReinitiateJourney}
            onClose={handleOnClose}
            modal={modal}
          />
        )}
        {modal.snackbar && (
          <NotificationMessage
            open={modal.snackbar}
            message={MESSAGE_SEND_AADHAAR_OTP}
            onClose={() => handleClose("snackbar", false)}
          />
        )}

        <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
          <Box
            flexDirection="column"
            display="flex"
            justifyContent="center"
            sx={{ width: "100%" }}
            textAlign="center"
          >
            <Typography variant="body1">
              Processing request, please wait.
            </Typography>
            <Box mt={2}>
              <CircularProgress color="inherit" />
            </Box>
          </Box>
        </Backdrop>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerEkycForm);
